import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { useHistory } from '@namespace/router';
import {
  MESSAGE_ICON_BY_TYPE,
  UNREAD_MESSAGE_TYPE
} from '../../../../../constants';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../../../../store';

import styles from './index.module.css';

const { REMOVE_NOTIFICATION_BY_MESSAGE_ID } = notificationCenterActions;

export const MessageItem = ({ data }) => {
  const { category, date, status, title, messageId } = data;
  const notifications = useNotificationCenterStore('notifications');
  const { isDesktop } = useDeviceStore();
  const { f } = useI18n();
  const DATE_FORMATS = f.getFormats();
  const { messagePreview } = useGeneralRoutes();
  const { push } = useHistory();

  return (
    <Box className={clsx([styles.container, styles[status]])}>
      <Box align="center" className={styles.mobileDate}>
        <AText
          breed={status === UNREAD_MESSAGE_TYPE ? 'B' : 'R'}
          size="m"
          color="po_txt_color_1"
        >
          {f
            .getDateTime({ date: date * 1000 })
            .toFormat(DATE_FORMATS.MESSAGES_NEW)}
        </AText>
      </Box>
      <Box align="center" justify="between" className={styles.content}>
        <Box align="center" className={styles.mainInfo}>
          <Box align="center">
            <Icon
              size={isDesktop ? 'm' : 's'}
              name={MESSAGE_ICON_BY_TYPE[category]}
              color="txt_color_1"
            />
          </Box>
          <Box align="center" className={styles.desktopDate}>
            <AText
              breed={status === UNREAD_MESSAGE_TYPE ? 'B' : 'R'}
              size="m"
              color="po_txt_color_1"
            >
              {f
                .getDateTime({ date: date * 1000 })
                .toFormat(DATE_FORMATS.MESSAGES_NEW)}
            </AText>
          </Box>
          <div className={styles.titleContainer}>
            <AText
              size="m"
              breed={status === UNREAD_MESSAGE_TYPE ? 'B' : 'R'}
              color="po_txt_color_1"
            >
              {title}
            </AText>
          </div>
        </Box>
        <Box
          onClick={() => {
            push(`${messagePreview}/${messageId}`);
            if (notifications.find(({ messageId: mId }) => mId === messageId)) {
              REMOVE_NOTIFICATION_BY_MESSAGE_ID(messageId);
            }
          }}
        >
          <Box align="center" justify="center" className={styles.detailsButton}>
            <Icon
              size="xs"
              name="icons/general/nav/go-to"
              color="txt_color_4"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
